<script lang="ts">
	import { resolve } from '$app/paths';
	import { page } from '$app/state';
	import { Toaster } from '$lib/components/ui/sonner/index.js';
	import { locales, localizeHref } from '$lib/paraglide/runtime';
	import {
		hideNavBarTopOnMobile,
		navBarAppearance,
		siteNavHeight
	} from '$lib/utils/marketing-routes';
	import CookieBanner from '@/components/cookie-banner.svelte';
	import Footer from '@/components/Footers/Footer.svelte';
	import LoginModal from '@/components/Modals/LoginModal.svelte';
	import NavBarBottom from '@/components/Navbars/NavBarBottom.svelte';
	import NavBarTop from '@/components/Navbars/NavBarTop.svelte';
	import { setPorts } from '@/stores/Port.svelte';
	import '../app.css';

	let { children } = $props();

	setPorts();

	const appearance = $derived(navBarAppearance(page.url.pathname));
	const hideTopOnMobile = $derived(hideNavBarTopOnMobile(page.url.pathname));
	const navHeight = $derived(siteNavHeight(appearance));
</script>

<Toaster />
<LoginModal />
<CookieBanner />
<div class="flex min-h-screen w-full flex-col" style="--site-nav-height: {navHeight}">
	<NavBarTop appearance={appearance} hideOnMobile={hideTopOnMobile} />
	<main class="grow pb-28 md:pb-0">
		{@render children?.()}
	</main>
	<Footer />
</div>
<NavBarBottom />

<div style="display:none">
	{#each locales as locale (locale)}
		<a href={resolve(localizeHref(page.url.pathname, { locale }))}>{locale}</a>
	{/each}
</div>
